import { Component, OnInit, Input, SimpleChanges, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import { IonIcon } from '@ionic/angular/standalone';
import { ReactiveFormsModule, ControlContainer, FormGroupDirective, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

export class MarvInputFile {    
    filename: string;
    url: string;
    filedata: File;
    base64: string|null = null; 
    
    toBase64(): Promise<string|null>{
        return new Promise(resolve => {  
            if(this.filedata){
                var reader = new FileReader();           
                reader.onload = function(event) {
                    let base64 = event.target?.result?.toString() || null;
                    resolve(base64);
                };           
                reader.readAsDataURL(this.filedata);
            }
            else{
                resolve(null);
            }
        });
    }       
}

@Component({
    selector: 'marv-input-file',
    templateUrl: './input-file.component.html',
    styleUrls: ['./input-file.component.scss'],
    imports: [IonIcon, ReactiveFormsModule],
    viewProviders: [
        {
            provide: ControlContainer,
            useExisting: FormGroupDirective
        }
    ]
})
export class MarvInputFileComponent  implements OnInit {

    @Input({alias : 'file', required : false}) file: MarvInputFile|null = null;
    @Input({alias : 'label', required : false}) labelInput: string = '';
    @Input({alias : 'fixedLabel', required : false}) fixedLabel: boolean = false;
    @Input({alias : 'icon', required : false}) iconInput: string = '';
    @Input({alias : 'formName', required : true}) formName: string|number = '';
    @Input({alias : 'errorText', required : false}) errorText: string = this.translateService.instant('MSG_ERROR_FIELD_MANDATORY');
    @Input({alias : 'disabled', required : false}) disabled: boolean = false;    
    @Input({alias : 'showBtnClearInput', required : false}) showBtnClearInput: boolean = false;
    @Input({alias : 'noMargin', required : false}) noMargin: boolean = false;
    @Input({alias : 'acceptFiles', required : false}) acceptFiles: Array<string> = [];
    @Output() fileChange = new EventEmitter<MarvInputFile|null>();

    @ViewChild('marvInputFile') marvInputFile: ElementRef;
    
    isRequired: boolean = false;
    
    updateStatusChange: Subscription;

    constructor(
        public translateService: TranslateService,
        public formGroupDirective: FormGroupDirective
    ) {}

    ngOnInit() {
        this.isRequired = this.formGroupDirective.form.controls[this.formName].hasValidator(Validators.required);
        this.updateStatusChange = this.formGroupDirective.form.controls[this.formName].statusChanges.subscribe((s) => {
            this.isRequired = this.formGroupDirective.form.controls[this.formName].hasValidator(Validators.required);
        });
    }

    async ngOnChanges(changes: SimpleChanges) {                
        if(changes['disabled'] && changes['disabled'].currentValue !== null){    
            if(this.disabled === true){
                this.formGroupDirective.form.controls[this.formName].disable({emitEvent: false});
            }
            else{
                this.formGroupDirective.form.controls[this.formName].enable({emitEvent: false});
            }
        }
    }
    
    ngOnDestroy() {           
        if(this.updateStatusChange){
            this.updateStatusChange.unsubscribe();
        }
    }
    
    getAcceptFiles(): string{
        let accept = '';
        if(this.acceptFiles.length > 0){
            accept = this.acceptFiles.map(f => { return (f.charAt(0) !== '.' ? '.'+f : f) }).join(', ');
        }
        return accept;
    }
    
    clearInput($event: any){
        $event.stopPropagation();  
        if(!this.disabled){
            if(this.formGroupDirective.form.controls[this.formName]){
                this.formGroupDirective.form.controls[this.formName].setValue(null);
                this.file = null;
                this.fileChange.emit(this.file);
            }
        }
    }
    
    selectFile(){        
        if(!this.disabled){
            this.marvInputFile.nativeElement.click();
        }
    }
    
    async onChangeFile($event: any){
        if($event.target?.files?.length > 0){
            let file = $event.target.files[0];
            this.file = new MarvInputFile();
            this.file.filename = file.name;
            this.file.filedata = file;
            this.file.base64 = await this.file.toBase64();
        }
        else{
            this.file = null;
        }
        this.fileChange.emit(this.file);
    }
}
